<template>
  <div class="home">
      <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">
               <a :href="slide.url"><img :src="slide.imgUrl" alt="" width="100%"></a>
          </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <div class="main-intro clearfix">
        <div class="news fl">
            <p class="tit">集团动态</p>
            <div class="news-info">
              <a href="/news-detail/222">
                <div class="news-pic">
                    <span :title="mainNews.summary">{{mainNews.summary}}</span>
                </div>
              </a>
                <div class="hover-trans">
                    <p class="news-title">
                      <a href="/news-detail/222">{{mainNews.title}}</a>
                    </p>
                    <p class="date">{{mainNews.date}}</p>
                    <ul>
                        <li v-for="(item, index) in newsList" :key="index" :title="item.text">
                            <a :href="`/news-detail/${item.id}`">
                                {{item.text}}
                            </a>
                        </li>
                    </ul>
                    <p class="more">
                        <a href="/news-list"><span>查看全部 ></span></a>
                    </p>
                </div>
            </div>
        </div>
        <!--<div class="business fl">-->
            <!--<p class="tit">业务板块</p>-->
            <!--<div class="business-info">-->
                <!--<div class="business-item clearfix">-->
                    <!--<a href="http://www.abccapital.cn" target="_blank">-->
                        <!--<span class="fl" style="border: 1px solid #dae0e9;"><img src="./logo-ziben.png" alt="" width="88"></span>-->

                        <!--<div class="content fr">-->
                            <!--<p class="title">亚商资本</p>-->
                            <!--<p class="text">亚商资本是中国成立最早，领先市场的风险投资和股权投资的专业投资平台。在移动互联网，新消费，大健康和文体娱乐领域有广泛的投资布局。</p>-->
                        <!--</div>-->
                    <!--</a>-->
                <!--</div>-->
                <!--<div class="business-item clearfix">-->
                    <!--<a href="https://www.abctougu.cn" target="_blank">-->
                        <!--<span class="fr" style="border: 1px solid #dae0e9;"><img src="./logo-tougu.png" alt="" width="88"></span>-->
                        <!--<div class="content fl">-->
                            <!--<p class="title">亚商投顾</p>-->
                            <!--<p class="text">亚商投顾是亚商集团的资产管理平台，前身为亚商咨询和亚商投行，是中国本土成立最早（1988年）、证监会首批颁发的投资顾问与并购重组持牌机构。</p>-->
                        <!--</div>-->
                    <!--</a>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="responsibility fl">
            <p class="tit">社会责任</p>
            <div class="respon-info">
              <div class="respon-info-item">
                <div>
                  <a href="/responsibility"><img src="./response4.png" alt="" width="171"></a>
                </div>
                <div class="cont">
                  <a href="/responsibility">初春四月 亚商送上暖心菜。</a>
                </div>
              </div>
                <div class="respon-info-item">
                    <div class="cont">
                        <a href="/responsibility">亚商正能量，防汛救灾，风雨同担。正经塾"豫"您一起。</a>
                    </div>
                    <div>
                        <a href="/responsibility"><img src="./response0.png" alt="" width="171"></a>
                    </div>
                </div>
<!--                <div class="respon-info-item">-->
<!--                    <div class="cont">-->
<!--                        <a href="/responsibility">亚商集团董事长携企业员工助力2018年上海光明半程马拉松赛。</a>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <a href="/responsibility"><img src="./response1.png" alt="" width="171"></a>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="respon-info-item">
                    <div>
                        <a href="/responsibility"><img src="./response2.png" alt="" width="171"></a>
                    </div>
                    <div class="cont">
                        <a href="/responsibility">亚商集团与一批志同道合的企业家好友共同发起资助黑龙江永续自然资源保护基金会。</a>
                    </div>
                </div>
                <div class="respon-info-item">
                    <div class="cont">
                        <a href="/responsibility">亚商集团联席总裁张琼女士自2006年起，捐资建设了夹寒箐镇么龙希望小学。</a>
                    </div>
                    <div>
                        <a href="/responsibility"><img src="./response3.png" alt="" width="171"></a>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <go-top></go-top>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
import goTop from "../../common/go-top.vue";
import banner1 from './banner1.jpg'
import banner2 from './banner2.jpg'
import banner3 from './banner3.jpg'
import banner4 from './banner4.jpg'
import banner5 from './banner5.jpg'
import banner0 from './banner0.jpg'

export default{
    name: 'Home',
    components: {
      goTop
    },
    data (){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                autoplay: {
                    stopOnLastSlide: true
                },
                loop: true,
                setWrapperSize :true,
                pagination : {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                observer:true,         //修改swiper自己或子元素时，自动初始化swiper
                observeParents:true,   //修改swiper的父元素时，自动初始化swiper
            },
            swiperSlides: [
              {imgUrl: banner0,url: '/news-detail/222'},
              {imgUrl: banner5,url: '/newsDetail/9'},
              {imgUrl: banner1,url: '/specialColumn'},
              {imgUrl: banner2,url: '/readingParty'},
              {imgUrl: banner3,url: '/gotoContent/introduce'},
              {imgUrl: banner4,url: '/responsibility'}
            ],
            mainNews: {
              summary: '2023长三角金融科技节',
              title: '重磅来袭 | 2023长三角金融科技节来啦',
              date: '2023.08.23'
            },
            newsList: [
              {
                id: 141,
                text: '第二届长三角金融科技创新与应用全球大赛启动仪式于沪成功举办'
              },
              {
                id: 138,
                text: '正回顾 | 颠覆时代下的引领与创新，对话新希望集团刘永好、席刚、泸宜遵谢明、成都先导李进、极米...'
              },
              {
                id: 139,
                text: '正经汇 | 掌门人正经塾 · 赛艇队正式起航啦'
              }
            ],
            mainRespon: {
                summary: '让中国大马哈鱼、鲟鳇鱼回家'
            }
        }
    },
    // components: {
    //     swiper,
    //     swiperSlide
    // },
    //  computed: {
    //     swiper() {
    //         return this.$refs.mySwiper.swiper
    //     }
    // },
}
</script>

<style scoped>

.swiper-button-prev{
    background-image:url("./button-prev.png");
    left: 20px;
}
.swiper-button-prev, .swiper-button-next{
    width: 48px;
    height: 48px;
    margin-top: -24px;
    background-size: 48px;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
}
.swiper-button-next{
    right: 20px;
    background-image:url("./button-next.png");
}
.swiper-button-next:hover{
    background-image:url("./button-next-active.png");
}
.swiper-button-prev:hover{
    background-image:url("./button-prev-active.png");
}
.home{
    min-width: 1200px;
}
.home .swiper-container img{
    width: 100%;
}
.main-intro{
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 75px;
}
.main-intro .tit{
    height: 75px;
    line-height: 75px;
    font-size: 22px;
    color: #09488A;
    text-align: left;
    font-weight: 600;
    margin-top: 15px;
}
.main-intro .tit img{
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
    width: 24px;
    height: 24px;
}

.main-intro .news,.main-intro .business,.main-intro .responsibility{
    width: 570px;
    /* overflow: hidden; */
}
.main-intro .news-info,.main-intro .business-info,.main-intro .respon-info{
    transition: all 0.2s ease;
    -webkit-transition: all 0.2s ease;
    background: #fff;
    height: 552px;
}
.main-intro .hover-trans{
    height: 336px;
    transition: all 0.2s ease;
    -webkit-transition: all 0.2s ease;
}
.main-intro .news-info:hover,.main-intro .business-info:hover,.main-intro .respon-info:hover{
    box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.1);
    transform: translateY(-6px);
    -webkit-transform: translateY(-6px);
}
.main-intro .business{
    margin: 0 20px;
}
.main-intro .news{
  margin-right: 20px;
}
.main-intro .responsibility{
  margin-left: 20px;
}
.main-intro .news-pic{
    background: url('./cover-news-2023.jpg') no-repeat 0 0;
    /*width: 100%;*/
    width: 380px;
    height: 192px;
    position: relative;
    margin-bottom: 24px;
    background-size: 100%;
}
.main-intro .news-pic span{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 20px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: rgba(0, 0, 0, 0.5);
    /* text-align: left; */
}

/* .main-intro .news-pic img{
    width: 100%;
} */
.main-intro .news-title{
    width: 100%;
    box-sizing: border-box;
    font-size: 18px;
    padding: 0 24px;
    text-align: justify;
}
.main-intro .news-title a{
  position: relative;
  display: block;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-weight: 600;
  line-height: 26px;
  color: #333;
}
/*.main-intro .news-title a::after{*/
  /*content: "...";*/
  /*position: absolute;*/
  /*bottom: 0;*/
  /*right: 0;*/
  /*padding-left: 7px;*/
  /*background: -webkit-linear-gradient(left, transparent, #fff 26%);*/
  /*background: -o-linear-gradient(right, transparent, #fff 26%);*/
  /*background: -moz-linear-gradient(right, transparent, #fff 26%);*/
  /*background: linear-gradient(to right, transparent, #fff 26%);*/
/*}*/
.news .date{
    text-align: right;
    line-height: 26px;
    font-size: 16px;
    padding: 0 24px;
    color: #333;
}
.news ul{
    padding: 24px 24px 10px 24px;
}
.news ul li:first-child{
    border-top: 1px solid #ddd;
}
.news ul li{
    font-size: 18px;
    line-height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #999;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    text-align: left;
}
.news ul li:hover a{
    color: #363636;
}

/* .main-intro .news-title,.main-intro .news-text{
    padding: 0 24px;
    color: #333;
}
.main-intro .news-text{
    color: #666;
    line-height: 24px;
    text-align: justify;
    margin-top: 20px;
} */
.main-intro .more{
    line-height: 60px;
    text-align: right;
    font-size: 14px;
    padding: 10px 24px 0 24px;
}
.main-intro .more span{
    color: #777;
    /* color: #333; */
    font-weight: 600;
}
.main-intro .business-info{
    padding: 0 20px;
    box-sizing: border-box;
}
.business-item{
    /* height: 196px; */
    padding: 24px 0;
}
.business-item:first-child{
    border-bottom: 1px solid #ddd;
}
.business .content .title{
    font-size: 20px;
    color: #333;
    text-align: left;
    font-weight: bold;
    padding: 10px 0;
}
.business .content{
    width: 230px;
}
.business .text{
    line-height: 28px;
    color: #666;
    text-align: justify;
    text-indent: 2em;
    font-size: 18px;
    /*font-weight: 300;*/
}

.main-intro .respon-info-item{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    height: 138px;
}

.respon-info ul li{
    height: 140px;
    overflow: hidden;
}
.respon-info ul li a{
    display: block;
}
.main-intro .respon-info .cont{
    width: 210px;
    padding: 20px 10px;
    text-align: justify;
    box-sizing: border-box;
    line-height: 28px;
    color: #666;
    font-size: 18px;
}
</style>




// WEBPACK FOOTER //
// src/components/home/Home.vue